import React from 'react';
import logoImg from "../../assets/logo.png";

import {LogoStyle} from "./styles";

const Logo = () => {
    return (
        <LogoStyle src={logoImg}/>
    );
};

export default Logo;
